import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles(theme => ({
   helperText: {
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '0px',
      fontSize: '11px',
      color: '#F44336'
   },
   button: {
      width: '95%',
      margin: '8px',
      height: '40px',
      color: 'white',
      background: '#3264DC'
   },
   formContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '3px'
   },
   formControl: {
      margin: '10px 8px',
      width: '95%',
      minWidth: 120,
      textAlign: 'initial',
      fontSize: '14px'
   },
   titleOne: {
      margin: '20px 0 15px 9px',
      fontStyle: 'normal',
      fontSize: 14,
      textAlign: 'left',
      color: '#8A8FAB',
      fontWeight: 400
   },
   multipleSelectLabel: {
      backgroundColor: 'white'
   },
   chips: {
      display: 'flex',
      flexWrap: 'wrap'
   },
   chip: {
      margin: 2
   },
   nameTitleCheckbox: {
      lineHeight: 1
   },
   nameSubTitleCheckbox: {
      fontSize: 12,
      opacity: 0.8,
      lineHeight: 1
   },
   groupOptionItem: {
      flexDirection: 'column',
      fontStyle: 'italic',
      paddingLeft: 10
   },
   massiveAssignCheckbox: {
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingBottom: 40,
      '& .MuiFormControlLabel-label' : {
         fontWeight: 400,
         fontSize: 14
      } 
   }
}))